import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { Trans } from '@/components/Trans'
import { cn } from '@/utils/style'

interface AutoRenewalSectionProps {
  value: boolean
  onChange: (value: boolean) => void
  className?: string
}

const OPTIONS: { label: ReactNode; value: boolean }[] = [
  { label: <Trans i18nKey="create.AutoRenewalSection.no">No</Trans>, value: false },
  { label: <Trans i18nKey="create.AutoRenewalSection.yes">Yes</Trans>, value: true },
]

export function AutoRenewalSection({ value, onChange, className }: AutoRenewalSectionProps) {
  const { t } = useTranslation()

  return (
    <div className="mt-6">
      <div className="t-sb mb-2 text-secondary">
        <Trans i18nKey="create.AutoRenewalSection.autoRenewal">Auto Renewal</Trans>
      </div>

      <div
        className="flex justify-start gap-2"
        role="radiogroup"
        aria-label={t('create.AutoRenewalSection.autoRenewal')}
      >
        {OPTIONS.map((option) => {
          const selected = value === option.value

          return (
            <button
              key={String(option.value)}
              type="button"
              role="radio"
              aria-checked={selected}
              className={cn(
                'flex items-center justify-start gap-2 rounded-xl border px-4 py-2 text-sm transition-colors',
                className,
                selected
                  ? 'border-secondary text-primary font-semibold'
                  : 'border-neutral-200 bg-panel-white text-secondary hover:bg-neutral-50',
              )}
              onClick={() => onChange(option.value)}
            >
              <span
                className={cn(
                  'flex h-4 w-4 items-center justify-center rounded-full border',
                  selected ? 'bg-btn-secondary dark:border-btn-secondary' : 'border-neutral-300',
                )}
              >
                <span
                  className={cn(
                    'h-1.5 w-1.5 rounded-full',
                    selected ? 'bg-panel-white' : 'bg-transparent',
                  )}
                />
              </span>
              <span className="t-sb">{option.label}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
